import { render, staticRenderFns } from "./webAboutUs.vue?vue&type=template&id=ea2cc604"
import script from "./webAboutUs.vue?vue&type=script&lang=js"
export * from "./webAboutUs.vue?vue&type=script&lang=js"
import style0 from "./webAboutUs.vue?vue&type=style&index=0&id=ea2cc604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports